import ModalHeader from './ModalHeader'
import ModalContent from './ModalContent'
import ModalContentWrapper from './ModalContentWrapper'
import ModalMainWrapper from './ModalMainWrapper'
import { useEffect } from 'react'

const DEFAULT_COACHING_MEETING_URL =
    'https://meetings.hubspot.com/kaylabragg/coaching-call-marketing-coach-round-robin?embed=true'

const CoachingCallModal = ({
    meetingUrl = DEFAULT_COACHING_MEETING_URL,
    title = 'Book a Coaching Call',
}) => {
    useEffect(() => {
        const script = document.createElement('script')
        script.src =
            'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js'
        script.async = true
        document.body.appendChild(script)

        return () => {
            document.body.removeChild(script)
        }
    }, [])

    return (
        <ModalMainWrapper>
            <ModalContentWrapper>
                <ModalHeader title={title} />
                <ModalContent>
                    <div
                        className="meetings-iframe-container h-full"
                        data-src={meetingUrl}></div>
                </ModalContent>
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}

export default CoachingCallModal
